/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import SuggestionDescriptor, { ISuggestion, ISuggestionJSON } from '../descriptors/suggestiondescriptor';

export interface IGetAllSuggestionResponse extends IMessage {
	suggestions?: string[];
	suggestionsV2?: ISuggestionJSON[];
}

export default class GetAllSuggestionResponse extends Message {
	public readonly suggestions: ISuggestion[];

	public static readonly DESCRIPTOR_NAME: string = 'TrackChangesGetAllSuggestionsResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			suggestions: {
				type: 'string',
				rule: 'repeated',
				id: 1
			},
			suggestionsV2: {
				type: 'SuggestionDescriptor',
				rule: 'repeated',
				id: 2
			}
		}
	};

	public constructor(
		private readonly _suggestions?: ISuggestion[],
		private readonly _suggestionsV2?: ISuggestion[]
	) {
		super();

		this.suggestions = _suggestionsV2?.length ? _suggestionsV2! : _suggestions!;
	}

	public toJSON(): IGetAllSuggestionResponse {
		return {
			suggestions: this._suggestions?.map( suggestion => JSON.stringify( suggestion ) ),
			suggestionsV2: this._suggestionsV2?.map( SuggestionDescriptor.toJSON )
		};
	}

	public static fromJSON( data: IGetAllSuggestionResponse ): GetAllSuggestionResponse {
		return new GetAllSuggestionResponse(
			data.suggestions?.map( _suggestionFromString ),
			data.suggestionsV2?.map( SuggestionDescriptor.fromJSON )
		);
	}
}

/**
 * Returns parsed suggestion.
 */
function _suggestionFromString( suggestion: string ): ISuggestion {
	const parsedSuggestion: ISuggestion = JSON.parse( suggestion );

	parsedSuggestion.createdAt = parsedSuggestion.createdAt ? new Date( parsedSuggestion.createdAt ) : undefined;

	return parsedSuggestion;
}
